import {
  Component, Vue,
} from 'vue-property-decorator';
import { Empty } from '@hb/coffee';


@Component
export default class DefaultPage extends Vue {
  private render() {
    return (
      <Empty
        desc="我们会在此页面展示您同意过的协议"
        button-text="去同意"
        onClick={() => this.$emit('goAgree')}
      />
    );
  }
}
